<template>
  <div class="kicked-screen">
    <div class="kicked-card">
      <div class="warning-icon">
        <img src="/warning.png" alt="Warning" width="120" height="120" />
      </div>
      <h2>Session Ended</h2>
      <p>Your session was ended, possibly because another device logged in to this account.</p>
      <button @click="goToLogin">Back to Agent Login</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentKickedView',
  methods: {
    goToLogin () {
      this.$router.replace('/agent-login')
    }
  }
}
</script>

<style scoped>
.kicked-screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.kicked-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 48px 40px;
  text-align: center;
  max-width: 420px;
  width: 100%;
}

.warning-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 28px;
}

.warning-icon img {
  display: block;
  margin: 0 auto;
}

h2 {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px;
}

p {
  font-size: 15px;
  color: #718096;
  line-height: 1.6;
  margin: 0 0 32px;
}

button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 14px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

@media (max-width: 480px) {
  .kicked-card {
    padding: 32px 24px;
  }
}
</style>

<style>
/* Dark mode */
.dark .kicked-screen {
  background: linear-gradient(135deg, #3b4a7a 0%, #4a2d6b 100%);
}

.dark .kicked-card {
  background: #1e2535;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
}

.dark .kicked-card h2 {
  color: #e2e8f0;
}

.dark .kicked-card p {
  color: #94a3b8;
}
</style>
